import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_axtc527c9j: FaireBrandEntity = {
  token: "b_axtc527c9j",
  type: "brand",
  name: "Humble Brands, Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/60c7e34a33f2e82531b139df6d29b22b82c2aa52f180f853f2acccd3dbd6aed8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0d05e9f00c883f9eec94463e7295c7b3f609622fecf147ab1674198d2c01426a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/60c7e34a33f2e82531b139df6d29b22b82c2aa52f180f853f2acccd3dbd6aed8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0d05e9f00c883f9eec94463e7295c7b3f609622fecf147ab1674198d2c01426a.png",
  location: "Taos, NM, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 275,
  isTopShop: true,
  isInsider: true,
  description:
    "Humble Brands creates simple and effective products for all bodies while being mindful of our impact on the planet and caring for our communities. Upon leaving his corporate career, Humble Brands Founder, Jeff Shardell began to prioritize a healthier lifestyle, right down to the products he put on his body. As he was incorporating more healthful changes into his daily routine, Jeff struggled to find an alternative to conventional antiperspirant that worked for him. Determined to find a better, simpler solution, Jeff began experimenting with ingredients in his kitchen. After much trial and error, he landed on a formula with 4 active ingredients that really worked. Jeff shared his deodorant with friends and family and was delighted that it worked for them too. Encouraged by the enthusiasm he received, the path toward creating Humble Brands was born. These days, Humble Brands is based in beautiful Taos, New Mexico. All of our products are crafted with the same less-is-more philosophy Jeff had at the outset. Creating the simplest, most effective personal care products is what we’re passionate about, and we’re excited to have you along!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:28.983Z",
    importedBy: "entity-db-cli",
  },
};
